<div class="product-grid" [ngClass]="{'layout-page' : layout === 'page', 'layout-with-facets' : layout === 'with-facets'}"><ng-content></ng-content></div>
